import React, { useState } from 'react';
import { Modal, Radio, Select, Button, message } from 'antd';
import dayjs from 'dayjs';
import { FAILURE_REASONS } from '../../constants/candidateColumnLabels';

const { Option } = Select;

// Преобразуем объект в массив для Select
const FAILURE_REASONS_OPTIONS = Object.entries(FAILURE_REASONS).map(([key, label]) => ({
    value: key,
    label: label
}));

const CompletionModal = ({
    visible,
    onCancel,
    onConfirm,
    loading = false
}) => {
    const [result, setResult] = useState('success');
    const [failureReason, setFailureReason] = useState(null);

    const handleConfirm = () => {
        if (result === 'failure' && !failureReason) {
            message.warning('Пожалуйста, выберите причину провала');
            return;
        }

        // Всегда отправляем сегодняшнюю дату
        const todayDate = dayjs().format('YYYY-MM-DD');

        const completionData = {
            result: result,
            completion_work: todayDate,
            ...(result === 'failure' && { failure_reason: failureReason })
        };

        onConfirm(completionData);
    };

    const handleCancel = () => {
        setResult('success');
        setFailureReason(null);
        onCancel();
    };

    return (
        <Modal
            title="Выберите результат завершения"
            visible={visible}
            onCancel={handleCancel}
            footer={[
                <Button key="cancel" onClick={handleCancel}>
                    Отмена
                </Button>,
                <Button
                    key="confirm"
                    type="primary"
                    onClick={handleConfirm}
                    loading={loading}
                >
                    Подтвердить
                </Button>
            ]}
            width={500}
        >
            <div style={{ marginBottom: 16 }}>
                <Radio.Group
                    value={result}
                    onChange={(e) => {
                        setResult(e.target.value);
                        if (e.target.value !== 'failure') {
                            setFailureReason(null);
                        }
                    }}
                >
                    <Radio value="success">Успех</Radio>
                    <Radio value="failure">Провал</Radio>
                    <Radio value="reserve">Кандидат в резерве</Radio>
                </Radio.Group>
            </div>

            {result === 'failure' && (
                <div style={{ marginTop: 16 }}>
                    <label style={{ display: 'block', marginBottom: 8, fontWeight: 'bold' }}>
                        Причина провала:
                    </label>
                    <Select
                        style={{ width: '100%' }}
                        placeholder="Выберите причину провала"
                        value={failureReason}
                        onChange={setFailureReason}
                    >
                        {FAILURE_REASONS_OPTIONS.map(reason => (
                            <Option key={reason.value} value={reason.value}>
                                {reason.label}
                            </Option>
                        ))}
                    </Select>
                </div>
            )}

            {result === 'success' && (
                <div style={{ marginTop: 16, textAlign: 'center', color: '#666' }}>
                    <p>Кандидат успешно завершен.</p>
                    <p>Дата завершения будет установлена на сегодня.</p>
                </div>
            )}

            {result === 'reserve' && (
                <div style={{ marginTop: 16, textAlign: 'center', color: '#666' }}>
                    <p>Кандидат будет добавлен в резерв.</p>
                    <p>Дата завершения будет установлена на сегодня.</p>
                </div>
            )}
        </Modal>
    );
};

export default CompletionModal;
